import * as S from './index.style'
import TextField from '@material-ui/core/TextField'
import { useState } from 'react'
import { Button, Modal } from '@material-ui/core'
import { DadosClonarViabilidade, ValidacaoDadosClonarViabilidade, clonarViabilidadeDefault } from '../../models/Viabilidade/DadosClonarViabilidade'
import { DialogHeader } from 'components/DialogHeader'
import { clonarViabilidadeCasas } from 'services/viabilidadeCasas.service'
import { useHistory } from 'react-router-dom'
import React from 'react'
import Loading from 'components/Loading'
import Box from '@material-ui/core/Box'
import { TipoSituacaoEnum } from 'models/Viabilidade/Enum/TipoSituacaoEnum'

export type ModalClonarViabilidadeProps = {
  idViabilidade: string
  situacaoViabilidade: TipoSituacaoEnum
  aberto: boolean
  closeDialogClonarViabilidade: () => void
  nomeTerreno: string | undefined
  areaTerreno: number | undefined
  dataCompraTerreno: string | undefined
  token: string | null
  fase: number
  idEmpreendimento?: string | null
}

export const ModalClonarViabilidade: React.FC<ModalClonarViabilidadeProps> = (props) => {
  const [valores, setValores] = useState<DadosClonarViabilidade>(clonarViabilidadeDefault)
  const [mensagensErro, setMensagensErro] = useState(new ValidacaoDadosClonarViabilidade())
  const [loading, setLoading] = React.useState(false)
  const history = useHistory()

  const nomeViabilidadeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const state = { ...valores } as Record<string, unknown>
    state[event.target.name] = event.target.value
    setValores(state as DadosClonarViabilidade)
  }

  const validarNomeViabilidadeClonar = () => {
    const erroNomeViabilidadeClonar = mensagensErro.validarNomeViabilidadeClonar(valores?.nomeViabilidadeClonar)

    const validador = new ValidacaoDadosClonarViabilidade(erroNomeViabilidadeClonar)

    setMensagensErro(validador)
    validarInput(validador)
  }

  const validarInput = (validador: ValidacaoDadosClonarViabilidade) => {
    valores.valido = validador.validarCard(valores.nomeViabilidadeClonar)
    setValores(valores)
  }

  const clonarViabilidade = async () => {
    setLoading(true)
    valores.idViabilidade = props.idViabilidade
    await clonarViabilidadeCasas(valores).then((respostaApi) => {
      if (respostaApi.entity) {
        history.push(`/terrenos/${respostaApi.entity.idTerreno}/viabilidades/nova-viabilidade`, {
          nomeTerreno: props.nomeTerreno,
          areaTerreno: props.areaTerreno,
          dataCompraTerreno: props.dataCompraTerreno,
          token: props.token,
          idViabilidade: respostaApi.entity.id,
          situacaoViabilidade: TipoSituacaoEnum.Rascunho,
          nomeViabilidadeClonada: respostaApi.entity.dadosGerais.nomeViabilidade,
          fase: props.fase,
          idEmpreendimento: props.idEmpreendimento
        })
      }
      setLoading(false)
      props.closeDialogClonarViabilidade()
    })
  }

  const validaBotaoClonarHabilitado = (): boolean => {
    return !valores.valido
  }

  return (
    <Modal open={props.aberto}>
      <S.BoxCustomizado data-cy="boxViabilidadeClonar">
        <DialogHeader titulo={'Duplicar viabilidade'} closedDialog={props.closeDialogClonarViabilidade}></DialogHeader>
        <S.Input>
          <S.Label>Insira um nome para a nova viabilidade</S.Label>
          <TextField
            name="nomeViabilidadeClonar"
            data-cy="campoNomeViabilidadeClonar"
            value={valores.nomeViabilidadeClonar}
            fullWidth
            placeholder="Ex.: Viabilidade Teste - Casas 01"
            variant="outlined"
            size="small"
            onChange={nomeViabilidadeHandler}
            onBlur={validarNomeViabilidadeClonar}
            inputProps={{ maxLength: 100 }}
            error={mensagensErro.nomeViabilidadeClonar != ''}
            helperText={mensagensErro.nomeViabilidadeClonar}
          />
        </S.Input>
        <S.Botoes>
          <Button
            disabled={loading}
            data-cy="btnCancelarClonar"
            variant="text"
            style={{ marginRight: '36px' }}
            color="primary"
            onClick={props.closeDialogClonarViabilidade}
          >
            Cancelar
          </Button>
          <Box sx={{ m: 1, position: 'relative' }}>
            <Button disabled={validaBotaoClonarHabilitado() || loading} data-cy="btnDuplicar" variant="contained" color="secondary" onClick={clonarViabilidade}>
              Duplicar
            </Button>
            {loading && <Loading />}
          </Box>
        </S.Botoes>
      </S.BoxCustomizado>
    </Modal>
  )
}

export default ModalClonarViabilidade
